// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"d6c0039b","821":"187f8e08","883":"74a1311e"}[chunkId] + ".chunk.js";
};